import React from 'react';
import { Button, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import MultiLocationContext from '../MultiLocationContext';
import message from '../../../Containers/ManualSearchV2/ManualSearchMessages';

const EnhancedAddLocationButton = props => {
  const { isRemoteJobChecked, locationContext, isFirstELement, currentLocation } = props;
  const {
    isLocationSelectionLimitReached,
    addLocationEnhanced,
    isCountryWideSearchEnabledCountry,
    isRegionDisabled,
    milesInputValidationError,
  } = React.useContext(MultiLocationContext);
  const isDisable =
    isLocationSelectionLimitReached ||
    isRemoteJobChecked ||
    isCountryWideSearchEnabledCountry ||
    (isRegionDisabled && locationContext === 'Region') ||
    milesInputValidationError;

  const isAddLocationDisabled =
    isLocationSelectionLimitReached ||
    isDisable ||
    (locationContext === 'Region' ? !currentLocation.Region : !currentLocation.Location);

  const onAddLocation = () => {
    !isAddLocationDisabled && addLocationEnhanced();
  };

  const getTooltipContentForDisabledLocation = ({
    isLocationSelectionLimitReached,
    isCountryWideSearchEnabledCountry,
  }) => {
    if (isLocationSelectionLimitReached) return <FormattedMessage {...message.youHaveReachedMaximumLocationLimitLabel} />;
    if (isCountryWideSearchEnabledCountry) return <FormattedMessage {...message.theSelectedCountryWillAllowOnlyCountrywideSearchLabel} />;
    return null;
  };

  return isAddLocationDisabled ? (
    <Tooltip
      title={getTooltipContentForDisabledLocation({
        isLocationSelectionLimitReached,
        isCountryWideSearchEnabledCountry,
      })}
    >
      <Button
        type="link"
        onClick={onAddLocation}
        style={{
          cursor: isAddLocationDisabled ? 'not-allowed' : '',
          color: isAddLocationDisabled ? '#51575e' : '',
        }}
      >
        <FormattedMessage {...message.addLocationLabel} />
      </Button>
    </Tooltip>
  ) : (
    <Button
      type="link"
      onClick={onAddLocation}
      style={{ cursor: isRemoteJobChecked ? 'not-allowed' : '', color: isRemoteJobChecked ? '#51575e' : '' }}
      disabled={milesInputValidationError}
    >
      {isFirstELement ? <FormattedMessage {...message.addLocationLabel} /> : <FormattedMessage {...message.addMoreLocationLabel} />}
    </Button>
  );
};

export default EnhancedAddLocationButton;
